import { render } from "./ReservedBookItem.vue?vue&type=template&id=7b137e02&scoped=true"
import script from "./ReservedBookItem.vue?vue&type=script&lang=js"
export * from "./ReservedBookItem.vue?vue&type=script&lang=js"

import "./ReservedBookItem.vue?vue&type=style&index=0&id=7b137e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b137e02"]])

export default __exports__